import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
//bootstrap
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";

//vuetify
import vuetify from "@/plugins/vuetify";

//i18n
import VueI18n from "@/plugins/vue-i18n";

//Plus Jakarta Sans
import './main.scss';
// scroll
import infiniteScroll from "@/plugins/infinity-scroll"

import apicaller from "@/utils/apicaller";
import 'leaflet/dist/leaflet.css';
//ResSplitPane
import ResSplitPane from "vue-resize-split-pane";
Vue.component("rs-panes", ResSplitPane);

//Pinch-zoom
import PinchZoom from 'vue-pinch-zoom';
Vue.component('pinch-zoom', PinchZoom);

import VueMask from 'v-mask'
Vue.use(VueMask);

import commonFunc from "./common.func";
import Toaster from './plugins/toaster';

//vuex store
import store from './store';

Vue.mixin({
  created: function () {
    this.successHandler = Toaster.successHandler;
    this.errorHandler = Toaster.errorHandler;
    this.warningHandler = Toaster.warningHandler;
    this.cancelHandler = Toaster.cancelHandler;
    this.languageLocalize = commonFunc.localize;
    this.localizeAlert = commonFunc.localizeAlert;
    this.deepCopy = commonFunc.deepCopy;
  }
});


import bOverlay from "./components/BOverlay.component.vue"
Vue.component("custom-loading", bOverlay);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.directive('appMode', {
  inserted(el, binding, vnode) {
    const applicationMode = localStorage.applicationMode;
    const applicationModeList = binding.value;
    let applicationModeChecked = false;

    for (const mode of applicationModeList) {
      if (mode == applicationMode) {
        applicationModeChecked = true;
        break;
      }
    }
    if (!applicationModeChecked) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})

Vue.directive('perm', {
  inserted(el, binding, vnode) {
    if (binding.value) {
      if (!localStorage.perms) {
        commonFunc.logOut();
      } else {
        let permList = localStorage.perms.split(';');
        let neededPermList = binding.value.split(",");
        let userHasPerms = false;

        for (let index = 0; index < neededPermList.length; index++) {
          if (permList.indexOf(neededPermList[index]) > -1) {
            userHasPerms = true;
            break;
          }
        }
        if (!userHasPerms && vnode.elm && vnode.elm.parentElement) {
          vnode.elm.parentElement.removeChild(vnode.elm)
        }
      }
    }
  }
})

//apicaller.defaults.timeout = 120000;
apicaller.interceptors.request.use(
  config => {
    let token = localStorage.access_token;
    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

apicaller.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      if (response.data == 401 || response.data.statusCode == 401) {
        commonFunc.logOut(true);
      } else if (response.data == 403 || response.data.statusCode == 403) {
        if (router.currentRoute.path != '/forbidden') {
          router.replace('/forbidden')
        }
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          console.log("400 error");
          //do something
          break;
        case 401:
          commonFunc.logOut(true);
          break;
        case 403:
          if (router.currentRoute.path != '/forbidden') {
            router.replace('/forbidden')
          }
          break;
        case 404:
          console.log("page not exist");
          break;
        case 502:
        // setTimeout(() => {
        //   router.replace({
        //     path: "/login",
        //     query: {
        //       redirect: router.currentRoute.fullPath
        //     }
        //   });
        // }, 1000);
      }
      return Promise.reject(error.response);
    } else if (error && error.message) {
      return Promise.reject(error);
    }
  }
);

const vue = new Vue({
  router,
  store,
  vuetify,
  VueI18n,
  Toaster,
  infiniteScroll,
  render: h => h(App)
});

Vue.prototype.$eventBus = vue;
vue.$mount("#app");